module.exports = __webpack_public_path__ + "img/img55.308532ab.png";